import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Shared-link mode: on expiry, silently renew the shared session once and retry
let renewing = null;
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  if (error.response?.status === 401 && !cfg._retried && !String(cfg.url).includes("/auth/")) {
    cfg._retried = true;
    renewing = renewing || axios.post(`${API}/auth/shared-session`).then((r) => {
      localStorage.setItem("yc_token", r.data.token);
    }).finally(() => { renewing = null; });
    try {
      await renewing;
      return api(cfg);
    } catch { /* fall through */ }
  }
  return Promise.reject(error);
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
